export default [
  {
    path: '/cyzsTopic/cyzsTopicList',
    name: 'cyzsTopicList',
    meta: {
      title: '专题列表'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsTopic/topicList/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsTopic/cyzsTopicEdit',
    name: 'cyzsTopicEdit',
    meta: {
      title: '专题编辑'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsTopic/topicList/edit.vue'], resolve)
    }
  },
  {
    path: '/cyzsTopic/topicCategorieList',
    name: 'topicCategorieList',
    meta: {
      title: '专题分类'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsTopic/topicCategory/main.vue'], resolve)
    }
  },
  {
    path: '/cyzsTopic/topicCategorieEdit',
    name: 'topicCategorieEdit',
    meta: {
      title: '专题分类编辑'
    },
    component(resolve) {
      require(['COMPONENTS/cyzsTopic/topicCategory/edit.vue'], resolve)
    }
  },
]